import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: () => ({
    openRequest: [],
    closeRequest: [],
    closeCall: [],
    openCall: [],
    todayJobs: [],
    upcomJobs: [],
    openInvoice: [],
    paidInvoice: [],
    equips: [],
    equipHeader: [],
    equipDetail: [],
    jobsList: [],
    invoiceHeader: [],
    invoiceDtl: [],
    contractHead: [],
    contractDtl: [],
    contractRenewal: [],
    quoteHead: [],
    quoteDtl: [],
    orderHead: [],
    orderDtl: [],
    shipHead: [],
    shipDtl: [],
    rmaHead: [],
    rmaDtl: [],
    memo: [],
    inventory: [],
    projectJobs: [],
    projectJobsDtls: [],
    home: {},
    hdcase: "",
    isDone: false,
    jobListBoard: [],
    technianList: [],
    driverList: [],
    equipList: [],
    transportPlans: [],
    bookingPlans: [],
  }),
  getters: getters,
  mutations: mutations,
  actions: actions,
};
